<template>
  <v-select
    :value="value"
    @input="value => emit(value)"
    :label="config.label"
    :items="occupations"
    item-text="name"
    item-value="code"
    :required="config.required"
    :error="haveErrors()"
    :rules="config.errors"
    dark>
  </v-select>
</template>

<script>
  import input from '@/mixins/input'
  import collection from './collection'
  export default {
    mixins: [input],
    computed: {
      occupations () {
        return collection(this, 'inputs.occupation')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/Occupation.vue